module.exports = __webpack_public_path__ + "static/media/loading-dock.b15b2962.jpeg";